import React from 'react';
import { Box, Divider, Typography, useTheme } from '@mui/material';

interface Props {
  title: string;
  subTitle: string;
  date: string;
  viewCount?: number;
}
const PostHeader = ({ title, subTitle, date, viewCount }: Props) => {
  const { spacing, palette, typography, breakpoints } = useTheme();

  return (
    <Box component="header" sx={{ marginBottom: spacing(5) }}>
      <Typography
        component="h1"
        fontSize={typography.h4.fontSize}
        fontWeight={typography.fontWeightBold}
        sx={{
          marginTop: spacing(2),
          [breakpoints.down('md')]: {
            fontsize: typography.h5.fontSize,
          },
        }}
      >
        {title}
      </Typography>
      <Typography fontFamily="Noto Sans" fontWeight={typography.fontWeightMedium}>
        {subTitle}
      </Typography>
      <Box display="flex" sx={{ marginTop: spacing(3), marginBottom: spacing(2), color: palette.grey['600'] }}>
        <Typography component="time" variant="caption" fontFamily="Noto Sans">
          {date}
        </Typography>
        {viewCount && (
          <Typography fontFamily="Noto Sans" variant="caption" sx={{ marginLeft: spacing(1) }}>
            / <strong>{viewCount.toLocaleString('ko-KR')}</strong> Views
          </Typography>
        )}
      </Box>
      <Divider />
    </Box>
  );
};

export default PostHeader;
